import React, { useState } from 'react';
import { TextField, Button, RadioGroup, FormLabel, FormControlLabel, FormControl } from '@mui/material';
import Typography from "@mui/material/Typography";
import Radio from '@mui/material/Radio';
import { CardContent } from '@mui/material';
import Card from '@mui/material/Card';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { sendEmail } from '../../utils/sendEmail';
import { Modal } from '../landingPage/Modal';

const ContactInfo = () => {
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [purposeOfContact, setPurposeOfContact] = useState('personal');
    const textMessage = encodeURI('Hola, me gustaría obtener más información sobre el proyecto.');
    const [successMessage, setSuccessMessage] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        // send email with the form data
        const data = {
            fullName: name + ' ' + lastName,
            email,
            phone,
            message,
            purposeOfContact
        }

        await sendEmail(data).then(result => {
            // clear the form
            setName('');
            setLastName('');
            setMessage('');
            setEmail('');
            setPhone('');
            setPurposeOfContact('personal');
            setSuccessMessage(true);
        });
    };

    return (
        <div className='contact-us' id='contact-us'>
            <Typography variant="h3" sx={{color: "var(--primary-color)", fontSize: '30px', fontWeight: 'bold', marginY: '40px', textTransform: 'uppercase'}} className='section-title'>Contáctanos</Typography>
            <div className='contact-us-container'>
                <Card className='contact-us-card'>

                    <CardContent >
                        <form onSubmit={handleSubmit}>
                            <TextField
                                label="Nombre"
                                name="name"
                                value={name}
                                onChange={(event) => setName(event.target.value)}
                                fullWidth
                                margin="normal"
                                variant="standard"
                                required={true}
                            />
                            <TextField
                                label="Apellido"
                                name="lastName"
                                value={lastName}
                                onChange={(event) => setLastName(event.target.value)}
                                fullWidth
                                margin="normal"
                                variant="standard"
                                required={true}
                            />
                            <TextField
                                label="Email"
                                name="email"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                fullWidth
                                margin="normal"
                                type="email"
                                variant="standard"
                                required={true}
                            />
                            <TextField
                                label="Teléfono"
                                name="telephone"
                                value={phone}
                                onChange={(event) => setPhone(event.target.value)}
                                fullWidth
                                margin="normal"
                                variant="standard"
                                required={true}
                            />

                            <FormControl className='radio-buttons'>
                                <FormLabel id="demo-radio-buttons-group-label">Propósito de la compra:</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    value={purposeOfContact}
                                    onChange={(event) => setPurposeOfContact(event.target.value)}
                                >
                                    <FormControlLabel value="personal" control={<Radio />} label="Uso Familiar" />
                                    <FormControlLabel value="investment" control={<Radio />} label="Inversión" />
                                </RadioGroup>
                            </FormControl>

                            <TextField
                                className='message-box'
                                id="outlined-multiline-static"
                                multiline
                                fullWidth
                                rows={4}
                                placeholder="Déjanos tu mensaje."
                                onChange={(event) => setMessage(event.target.value)}
                                value={message}
                            />

                            <Button type="submit" variant="contained" sx={{ backgroundColor: 'var(--primary-color)'}}>
                                Enviar
                            </Button>
                        </form>
                    </CardContent>
                </Card>

                <div className='follow-info'>
                    <Card className='contact-us--follow-card'>
                        <a href="https://www.instagram.com/lomasdonquifo/#" target='_blank' rel='noreferrer'>
                            <CardContent className='contact-us-card-content'>
                                <InstagramIcon sx={{fontSize: 40, color: 'var(--primary-color)'}}/>
                                <Typography variant="h5" sx={{
                                    color: '#37391F',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    marginTop: '40px',
                                    textTransform: 'uppercase'
                                }}>Síguenos en Instagram</Typography>
                                <hr className="solid"/>
                                <Typography variant="p" sx={{
                                    color: '#37391F',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    marginTop: '40px',
                                }}>@lomasdonquifo</Typography>
                            </CardContent>
                        </a>
                    </Card>

                    <Card className='contact-us--follow-card'>
                        <a href={`https://wa.me/18299080404?text=${textMessage}`} target='_blank' rel='noreferrer' aria-label="Chat on WhatsApp">
                            <CardContent className='contact-us-card-content'>
                                <WhatsAppIcon sx={{fontSize: 40, color: 'var(--primary-color)'}}/>
                                <Typography variant="h5" sx={{
                                    color: '#37391F',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    marginTop: '40px',
                                    textTransform: 'uppercase'
                                }}>Habla con nosotros por WhatsApp</Typography>
                                <hr className="solid"/>
                            </CardContent>
                        </a>
                    </Card>

                    <Card className='contact-us--follow-card'>
                        <a href="mailto:lomasdonquifo@gmail.com?subject=Request Information" target='_blank' rel='noreferrer'>
                            <CardContent className='contact-us-card-content'>
                                <EmailIcon sx={{fontSize: 40, color: 'var(--primary-color)'}}/>
                                <Typography variant="h5" sx={{
                                    color: '#37391F',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    marginTop: '40px',
                                    textTransform: 'uppercase'
                                }}>Email</Typography>
                                <hr className="solid"/>
                                <Typography variant="h5" sx={{
                                    color: '#37391F',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                }}>lomasdonquifo@gmail.com</Typography>
                            </CardContent>
                        </a>
                    </Card>
                </div>
            </div>
            {successMessage && <Modal />}
        </div>);
}

export default ContactInfo;
